import { render, staticRenderFns } from "./CompleteDiscussion.vue?vue&type=template&id=537187dc"
import script from "./CompleteDiscussion.vue?vue&type=script&lang=js"
export * from "./CompleteDiscussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports